// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageContainer_image__1wL9k"};